<template>
    <div>
        <hr>

        <h3>What happens next?</h3>

        <p>You have chosen to collect your order from our trade desk in Watford</p>
        <div class="process-steps">
            <div class="row">
                <div class="col-md-4">
                    <h4>Step one</h4>
                    <p>Once you have submitted your order, we will process it and start putting your order together.</p>
                </div>
                <div class="col-md-4">
                    <h4>Step Two</h4>
                    <p>
                        Your order will be stored securely at our centre, ready for your arrival, please allow up to 3 hours for your items to be ready.
                    </p>
                </div>
                <div class="col-md-4">
                    <h4>Step Three</h4>
                    <p>
                        You arrive at our trade desk, make payment and pick up your items.
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12 text-right">
                <button class="btn btn-green" @click="submit" :disabled="processing">
                    <template v-if="!processing">
                        <i class="fa fa-lock"></i> Submit Order
                    </template>
                    <template v-else>
                        <i class="fa fa-refresh fa-spin"></i> Processing
                    </template>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Checkout from '../../../Services/Checkout.js';
    import Order from '../../../Services/Order';

    export default {
        props: ['gatewayId'],
        data() {
            return {
                processing: false,
                checkout: Checkout,
                order: Order.order,
            }
        },
        methods: {
            submit() {
                this.checkout.setType('Collection')
                .setGatewayId(this.gatewayId).process(
                    undefined,
                    undefined,
                    this.order.reference,
                    this.order.notes
                ).then(response => {
                    this.$emit('complete');
                }).catch(error => {
                    this.$emit('failed');
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/Payments/CollectionGateway.vue